import { SubscriptionSource } from '../constants';

import type { MemberSubscription } from '../types';

export const getActiveSubscription = (
  subscriptions?: MemberSubscription[],
): MemberSubscription | null => {
  if (!subscriptions) {
    return null;
  }
  return (
    subscriptions.find(({ source, expirationDate }) => {
      return (
        source === SubscriptionSource.Gym ||
        (expirationDate &&
          new Date(expirationDate).getTime() > new Date().getTime())
      );
    }) ?? null
  );
};
